/**
 * Dollar text to nonnegative integer cents, shared by tax forms. Kept as text
 * until validated: an empty answer is not zero, and a float multiply can change
 * the last cent of a large but safe amount. A leading $ and correctly grouped
 * commas are accepted; exponents, extra decimals and unsafe cents are refused.
 */
export function parseDollarsToCents(raw: string): number | null {
  const cleaned = raw.trim().replace(/^\$\s*/, '')
  if (cleaned.length > 128 || !/^(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d{1,2})?$/.test(cleaned)) return null
  const [whole, fraction = ''] = cleaned.replace(/,/g, '').split('.')
  const cents = BigInt(whole) * 100n + BigInt(fraction.padEnd(2, '0'))
  return cents <= BigInt(Number.MAX_SAFE_INTEGER) ? Number(cents) : null
}
